import { ReactNode } from "react";
import { action, observable } from "mobx";

export type TPanelOption = {
    title?: string;
    logo?: boolean;
    full?: boolean;
    noPadding?: boolean;
    children: ReactNode;
    closeable?: boolean;
    onClose?: () => void;
    withSpinner?: boolean;
    opened: boolean;
};

class PanelStore {
    @observable option: TPanelOption | undefined;

    @action open(option: TPanelOption) {
        this.option = option;
    }

    @action close() {
        this.option = undefined;
    }
}

const panelStore = new PanelStore();
export { panelStore };
